import { render, staticRenderFns } from "./PurchaseOrderShow.vue?vue&type=template&id=2647cd7c&scoped=true&"
import script from "./PurchaseOrderShow.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderShow.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderShow.vue?vue&type=style&index=0&id=2647cd7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2647cd7c",
  null
  
)

export default component.exports